import React from 'react';
import { motion } from 'framer-motion';
import { mockData } from '../data/mock';
import { revealVariants, staggerContainer } from '../utils/motion';

export const Terms = () => {
  return (
    <div className="pt-20 min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-20">
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          animate="visible"
          className="max-w-4xl mx-auto bg-white rounded-3xl shadow-lg p-8 md:p-12"
        >
          <motion.h1 
            variants={revealVariants}
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-8"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Terms of Service
          </motion.h1>

          <motion.div variants={revealVariants} className="prose max-w-none">
            <p className="text-gray-600 mb-8 text-lg">
              <strong>Last updated:</strong> January 2025
            </p>

            <div className="space-y-8">
              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Agreement to Terms</h2>
                <p className="text-gray-700 leading-relaxed">
                  By accessing and using the services of {mockData.company.name} ("SAX", "we", "us", or "our"), 
                  you agree to be bound by these Terms of Service and all applicable laws and regulations.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Services</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  SAX provides professional consulting services including but not limited to:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>Technology Consulting and Digital Transformation</li>
                  <li>Mining and Survey Operations</li>
                  <li>Financial Consulting and Analysis</li>
                  <li>Project Management Services</li>
                  <li>Business Advisory and Strategic Planning</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Professional Relationship</h2>
                <p className="text-gray-700 leading-relaxed">
                  Our services create a professional consulting relationship. All work is performed based on 
                  signed agreements that specify scope, deliverables, timelines, and compensation. These terms 
                  supplement but do not replace specific project agreements.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Client Responsibilities</h2>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>Provide accurate and complete information</li>
                  <li>Grant necessary access to systems and personnel</li>
                  <li>Meet agreed-upon timelines and commitments</li>
                  <li>Pay fees according to agreed terms</li>
                  <li>Maintain confidentiality of proprietary methodologies</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Intellectual Property</h2>
                <p className="text-gray-700 leading-relaxed">
                  SAX retains ownership of its proprietary methodologies, tools, and general knowledge. 
                  Client-specific deliverables and recommendations become the property of the client upon 
                  full payment, unless otherwise specified in the project agreement.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Confidentiality</h2>
                <p className="text-gray-700 leading-relaxed">
                  We maintain strict confidentiality regarding all client information and business matters. 
                  Clients are expected to maintain similar confidentiality regarding SAX's proprietary 
                  methods and any non-public information shared during the engagement.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Limitation of Liability</h2>
                <p className="text-gray-700 leading-relaxed">
                  SAX provides professional advice and recommendations based on available information. 
                  Our liability is limited to the fees paid for the specific service. We are not responsible 
                  for implementation decisions or results beyond our direct control.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Governing Law</h2>
                <p className="text-gray-700 leading-relaxed">
                  These terms are governed by the laws of the United Arab Emirates. Any disputes will be 
                  resolved through the courts of Dubai, UAE, unless otherwise agreed in writing.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact Information</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  For questions about these Terms of Service, please contact us:
                </p>
                <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                  <p><strong>{mockData.company.name}</strong></p>
                  <p>{mockData.company.location}</p>
                  <p>Email: {mockData.company.email}</p>
                  <p>Phone: {mockData.company.phone}</p>
                  <p>WhatsApp: {mockData.company.whatsapp}</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Updates to Terms</h2>
                <p className="text-gray-700 leading-relaxed">
                  We reserve the right to update these terms at any time. Material changes will be 
                  communicated to active clients. Continued use of our services constitutes acceptance 
                  of updated terms.
                </p>
              </section>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};